module.exports = __webpack_public_path__ + "assets/img/q2.ca6d7be9.png";